import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  divider: {
    alignSelf: 'stretch',
    height: 'auto',
    margin: theme.spacing(1, 0.5),
  },
  toolBar: {
    visibility: props => (props.show ? 'visible' : 'hidden'),
    width: 380,
    top: -68 - theme.spacing(0.5),
    left: -5,
    padding: theme.spacing(0.5, 1),
    position: 'absolute',
    display: 'flex',
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
  },
}))

export default useStyles
